module.exports = __webpack_public_path__ + "static/img/blog-img5.48cfcf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-img5.jpg
// module id = 86DR
// module chunks = 1